const rankingItems = [
  { rank: 1, title: '星际迷航：新纪元', type: '电影', tag: '热播中', hot: '9.6', desc: '史诗级科幻巨制，视觉特效震撼人心' },
  { rank: 2, title: '长安十二时辰', type: '电视剧', tag: '爆款', hot: '9.5', desc: '古装悬疑大剧，剧情环环相扣' },
  { rank: 3, title: '极限挑战第十季', type: '综艺', tag: '新季', hot: '9.4', desc: '国民级户外真人秀重磅回归' },
  { rank: 4, title: '进击的巨人 终章', type: '动漫', tag: '完结', hot: '9.3', desc: '现象级动画迎来史诗大结局' },
  { rank: 5, title: '流浪地球3', type: '电影', tag: '热门', hot: '9.2', desc: '国产科幻里程碑续作引爆期待' },
  { rank: 6, title: '繁花', type: '电视剧', tag: '口碑', hot: '9.1', desc: '王家卫执导年代大剧，质感拉满' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          热播榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          本周最受欢迎内容，看看大家都在看什么
        </p>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 border border-background-200/60 rounded-lg p-4 hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 font-heading font-bold text-sm ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-800 truncate">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                <span className="text-xs text-foreground-400 bg-secondary-50 px-2 py-0.5 rounded-full whitespace-nowrap">{item.type}</span>
                <span className="text-sm font-bold text-accent-600">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}